function less_clothing_items (plan_name,customer_subscription,no_of_membership_clothes) {
  var less_clothing_items_count = (ALLOWED_PRODUCTS[customer_subscription]["clothing"] - no_of_membership_clothes);
  var clothing_grammar = null;

  if (less_clothing_items_count == 1)
  {
    clothing_grammar = "With the " + plan_name + " plan you are allowed to get " + less_clothing_items_count + " more clothing item. Are you sure you want to checkout without an extra free clothing item?";
  }
  else if (less_clothing_items_count > 1)
  {
    clothing_grammar = "With the " + plan_name + " plan you are allowed to get " + less_clothing_items_count + " more clothing items. Are you sure you want to checkout without extra free clothing items?";
  }

  fancyconfirm(clothing_grammar, {
    buttons: [
      {
        class: "yes",
        type: "button",
        title: "Yes",
        value: "yes"
      }, {
        class: "no",
        type: "button",
        title: "No",
        value: "no"
      }
    ],
    modal: true
  },
               function (resp) {
    if(resp == "yes"){
      window.location.href = STORE_URL + "/checkout";
    }
  });
}